<template>
<div class="chapter">
<div class="inner_page">
<h1>The Pocket Guide to Brilliance</h1><div class="toc"><p><b>Table of Contents</b></p><dl><dt><span class="chapter"><a href="#/ch01">Introduction</a></span></dt><dt><span class="chapter"><a href="#/ch02">Quick Wits and Canny Minds</a></span></dt><dt><span class="chapter"><span href="#/ch03" title="Link target outside of Sample">Plymouth Rocks</span></span></dt><dt><span class="chapter"><span href="#/ch04" title="Link target outside of Sample">Bad Habits and Funky Customs</span></span></dt><dt><span class="chapter"><span href="#/ch05" title="Link target outside of Sample">Talkin’ ’Bout a Revolution</span></span></dt><dt><span class="chapter"><span href="#/ch06" title="Link target outside of Sample">How to Win an Election</span></span></dt><dt><span class="chapter"><span href="#/ch07" title="Link target outside of Sample">Wanna Be a Cowboy?</span></span></dt><dt><span class="chapter"><span href="#/ch08" title="Link target outside of Sample">Playin' It Old School</span></span></dt><dt><span class="chapter"><span href="#/ch09" title="Link target outside of Sample">Brilliant Women</span></span></dt><dt><span class="chapter"><span href="#/ch10" title="Link target outside of Sample">Brilliant Leaders</span></span></dt><dt><span class="chapter"><span href="#/ch11" title="Link target outside of Sample">Great Expectorations</span></span></dt><dt><span class="chapter"><span href="#/ch12" title="Link target outside of Sample">Not-So-Brilliant Villains</span></span></dt><dt><span class="chapter"><span href="#/ch13" title="Link target outside of Sample">Forgotten Brilliance</span></span></dt></dl></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?4067bae6